import { RefObject } from "react";
import {
	IShopPurchaseOfferMultiItem,
	IShopSection
} from "contexts/WebStoreProvider/types";
import getSectionIcon from "utils/svgIcons";
import { FeaturedOfferCard } from "../FeaturedOfferCard";
import Section from "components/Section";
import { sortByPriority } from "utils/sort";
import { FeaturesFlags } from "helpers/flagsConfig";
import { useEnvContext } from "contexts";
import { SxProps } from "@mui/material";

const FeaturedOfferSection = ({
	data,
	sectionRef,
	sectionOffers,
	headerSx
}: {
	className?: string;
	data: IShopSection;
	sectionRef: RefObject<HTMLElement>;
	sectionOffers: IShopPurchaseOfferMultiItem[];
	headerSx?: SxProps;
}): JSX.Element => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const offers: JSX.Element[] = sortByPriority(sectionOffers)
		.filter((offer) => {
			if (offer?.rebateConfig && !isFeatureFlagEnabled(FeaturesFlags.REBATE)) {
				return false;
			}
			return true;
		})
		.map((offer) => (
			<FeaturedOfferCard
				data={offer as IShopPurchaseOfferMultiItem}
				key={offer.rewardId}
				sectionName={data.name}
			/>
		));

	const sectionProps = {
		offers,
		sectionRef,
		headerText: data.title,
		iconUrl: getSectionIcon(data.name)?.url,
		icon: getSectionIcon(data.name)?.svg,
		display: "carousel",
		sectionPage: "featured",
		headerSx
	};

	return <Section {...sectionProps} />;
};

FeaturedOfferCard.displayName = "FeaturedOfferSection";

export { FeaturedOfferSection };
